import { useState, useRef } from "react";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import ModernHotelImage1 from '../../assets/modern-hotel-image-1.png'
import ModernHotelImage2 from '../../assets/modern-hotel-image-2.png'
import ModernHotelImage3 from '../../assets/modern-hotel-image-3.png'
import ModernHotelImage4 from '../../assets/modern-hotel-image-4.png'
import ModernHotelImage5 from '../../assets/modern-hotel-image-5.png'
import ModernHotelImage6 from '../../assets/modern-hotel-image-6.png'
import ModernHotelImage7 from '../../assets/modern-hotel-image-7.png'
import ModernHotelImage8 from '../../assets/modern-hotel-image-8.png'
import ManyIndustriesIcon1 from '../../assets/many-industries-icon-1.png'
import ManyIndustriesIcon2 from '../../assets/many-industries-icon-2.png'
import ManyIndustriesIcon3 from '../../assets/many-industries-icon-3.png'
import BulbImage from '../../assets/bulb-image-many-hotels.png'
import SmartUpsellingIcon1 from '../../assets/smart-upselling-icon-1.png'
import SmartUpsellingIcon2 from '../../assets/smart-upselling-icon-2.png'
import SmartUpsellingIcon3 from '../../assets/smart-upselling-icon-3.png'
import PrimaryIntegrationImage from '../../assets/primary-integration-image.png'
import HotelVariousImage1 from '../../assets/hotel-various-image-1.jpg'
import HotelVariousImage2 from '../../assets/hotel-various-image-2.jpg'
import HotelVariousImage3 from '../../assets/hotel-various-image-3.jpg'
import HotelVariousImage4 from '../../assets/hotel-various-image-4.jpg'
import PointTick from '../../assets/point-tick.png'
import WhiteColorTick from '../../assets/white-color-tick.png'
import WhatsappSmallIcon from '../../assets/whatsapp-small-icon.png'
import sendMessageImage from '../../assets/send-message-image.png'
import MessageIcon from '../../assets/message-icon-home-1.png'
import LocationIcon from '../../assets/location-icon-contactus.png'
import './Hotel.css'
import { TypeAnimation } from 'react-type-animation';


const hotelData = [
    {
        name: "Hotels",
        title: " Hotels",
        points: [
            "Simplify room & dining billing in one system.",
            "Multi-location hotel chain support.",
            "Real-time reporting for management.",
        ],
        image: HotelVariousImage1,
    },
    {
        name: "Lounges & Clubs",
        title: "Lounges & Clubs",
        points: [
            "Streamlined bar & beverage management.",
            "Happy-hour pricing automation.",
            "Quick billing for table service.",
        ],
        image: HotelVariousImage2,
    },
    {
        name: "Resorts",
        title: "Resorts",
        points: [
            "Guests charge all resort services to their room for one simple checkout bill.",
            "Manage stock across all resort outlets (restaurants, shops, bars) from a single system.",
            "Seamlessly handle and bill for spa, activities, and other resort service appointments",
        ],
        image: HotelVariousImage4,
    },
    {
        name: "Service Apartments / Stays",
        title: "Service Apartments / Stays",
        points: [
            "Digital check-in/check-out.",
            "Seamless kitchen & housekeeping requests.",
            "QR code menu ordering in rooms.",
        ],
        image: HotelVariousImage3,
    }
];

function Hotel() {
    const [selected, setSelected] = useState(hotelData[0]);
    const [activeView, setActiveView] = useState('contact');
    const sectionRef = useRef(null);

    const scrollToSection = () => {
        sectionRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    const [formData, setFormData] = useState({
        name: "",
        product: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleWhatsAppSubmit = (e) => {
        e.preventDefault();

        const phoneNumber = "+917386616587";
        const { name, product } = formData;

        const whatsappMessage = `Hey, I am ${name}.\n\nI am interested in ${product} POS.\n\nLooking forward to a demo!`;

        const encodedMessage = encodeURIComponent(whatsappMessage);

        const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodedMessage}`;

        window.open(whatsappUrl, "_blank");
        setFormData({
            name: "",
            product: "",
        });
    };
    return (
        <>
            <Navbar />
            <div className="hotel-home-page-main-container">
                <div className="hotel-content-container">
                    {/* <h1 className="hotel-main-heading">Seamless PMS for <span className="hotel-main-span">Lounges, Stays & Resorts</span></h1> */}
                    <TypeAnimation
                        sequence={[
                            // Same substring at the start will only be typed out once, initially
                            'Manage Your Hospitality Business Seamlessly',
                            1000, // wait 1s before replacing "Mice" with "Hamsters"
                            'Manage Your Hospitality Business Seamlessly - for Hotels',
                            2000,
                            'Manage Your Hospitality Business Seamlessly - for Lounges & Clubs',
                            2000,
                            'Manage Your Hospitality Business Seamlessly - for Resorts',
                            2000,
                            'Manage Your Hospitality Business Seamlessly - for Serviced Apartments, and Stays',
                            2000
                        ]}
                        wrapper="span"
                        speed={50}
                        // style={{ fontSize: '42px', display: 'inline-block',color:"white",fontWeight:"bold",marginTop:"12px" }}
                        className="hotel-main-heading"
                        repeat={Infinity}
                    />
                    <p className="hotel-main-description">Simplify operations, delight guests, and maximize revenue with our all-in-one PMS solution designed specifically for the hospitality industry.</p>
                    <button className="hotel-main-button" onClick={scrollToSection}>Get Started Today</button>
                </div>
            </div>

            <div className="modern-hotels-main-container">
                <h1 className="modern-hotels-main-heading">Powerful <span className="modern-main-span">Features</span> for Modern Hotels</h1>
                <p className="modern-hotels-main-description">Everything you need to run your hotel efficiently, all in one integrated system</p>
                <div className="modern-hotel-cards-section">

                    <div className="modern-hotel-card card-1">
                        <div className="modern-hotel-card-content-container">
                            <h1 className="modern-hotel-card-title">Front Desk Management</h1>
                            <p className="modern-hotel-card-description">Streamline check-ins, check-outs, and guest services with our intuitive front desk interface. Manage reservations and guest preferences effortlessly.</p>
                        </div>
                        <div className="modern-hotel-image-section">
                            <img src={ModernHotelImage1} alt="Modern-image-1" className="modern-hotel-image" />
                        </div>
                    </div>

                    <div className="modern-hotel-card card-2">
                        <div className="modern-hotel-image-section">
                            <img src={ModernHotelImage2} alt="Modern-image-1" className="modern-hotel-image" />
                        </div>

                        <div className="modern-hotel-card-content-container">
                            <h1 className="modern-hotel-card-title">Room Service Ordering</h1>
                            <p className="modern-hotel-card-description">Enable seamless room service with digital ordering. Guests can order directly from their rooms while staff track and fulfill requests efficiently.</p>
                        </div>
                    </div>

                    <div className="modern-hotel-card card-2">
                        <div className="modern-hotel-card-content-container-card-3">
                            <h1 className="modern-hotel-card-title">Reservation Center</h1>
                            <p className="modern-hotel-card-description">Our PMS system for hotels lets you manage all bookings and reservations via a single window in an easier way without compromising the quality of service.</p>
                        </div>
                        <div className="modern-hotel-image-section">
                            <img src={ModernHotelImage3} alt="Modern-image-1" className="modern-hotel-image" />
                        </div>
                    </div>

                    <div className="modern-hotel-card card-1">
                        <div className="modern-hotel-card-content-container">
                            <h1 className="modern-hotel-card-title">Profile Management</h1>
                            <p className="modern-hotel-card-description">You can manage multiple profiles by using our cloud-based hotel PMS system. To name a few, this can be for corporate guests, room owners, travel agents, and business sources. </p>
                        </div>
                        <div className="modern-hotel-image-section">
                            <img src={ModernHotelImage4} alt="Modern-image-1" className="modern-hotel-image" />
                        </div>
                    </div>

                    <div className="modern-hotel-card card-1">
                        <div className="modern-hotel-image-section">
                            <img src={ModernHotelImage6} alt="Modern-image-1" className="modern-hotel-image" />
                        </div>
                        <div className="modern-hotel-card-content-container">
                            <h1 className="modern-hotel-card-title">Reports & Analytics</h1>
                            <p className="modern-hotel-card-description">Comprehensive insights into your hotel performance. Track revenue, occupancy, and operational metrics with detailed reporting tools.</p>
                        </div>
                    </div>

                    <div className="modern-hotel-card card-2">
                        <div className="modern-hotel-card-content-container-7">
                            <h1 className="modern-hotel-card-title">Franchise</h1>
                            <p className="modern-hotel-card-description">Manage multiple properties from one centralized system. Perfect for hotel chains and management companies with diverse portfolios.</p>
                        </div>
                        <div className="modern-hotel-image-section">
                            <img src={ModernHotelImage5} alt="Modern-image-1" className="modern-hotel-image" />
                        </div>
                    </div>

                    <div className="modern-hotel-card card-2">
                        <div className="modern-hotel-card-content-container-7">
                            <h1 className="modern-hotel-card-title">Staff & Role Management</h1>
                            <p className="modern-hotel-card-description">Control access levels and permissions for different staff roles. Ensure security while empowering your team with appropriate system access.</p>
                        </div>
                        <div className="modern-hotel-image-section">
                            <img src={ModernHotelImage7} alt="Modern-image-1" className="modern-hotel-image" />
                        </div>
                    </div>

                    <div className="modern-hotel-card card-1">
                        <div className="modern-hotel-image-section">
                            <img src={ModernHotelImage8} alt="Modern-image-1" className="modern-hotel-image" />
                        </div>
                        <div className="modern-hotel-card-content-container">
                            <h1 className="modern-hotel-card-title">24/7 Support</h1>
                            <p className="modern-hotel-card-description">Round-the-clock technical support ensures your operations never stop. Expert assistance available whenever you need it most.</p>
                        </div>
                    </div>

                </div>
            </div>

            <div className="many-hotel-industries-main-container">
                <div className="many-hotel-main-heading-container">
                    <h1 className="many-hotel-main-heading">One PMS, Many Hotel Industries</h1>
                    <p className="many-hotel-main-description">From local Hotels to global Stays, we've got you covered.</p>
                </div>

                <div className="many-industries-cards-container">
                    <div className="many-industries-card many-card-1">
                        <img src={ManyIndustriesIcon1} alt="many-industries-icon" className="many-industries-icon" />
                        <h1 className="many-nidustries-card-title">Hotels & Resorts</h1>
                    </div>

                    <div className="many-industries-card many-card-2">
                        <img src={ManyIndustriesIcon2} alt="many-industries-icon" className="many-industries-icon" />
                        <h1 className="many-nidustries-card-title">Lounges & Clubs</h1>
                    </div>

                    <div className="many-industries-card many-card-3">
                        <img src={ManyIndustriesIcon3} alt="many-industries-icon" className="many-industries-icon" />
                        <h1 className="many-nidustries-card-title">Service  Stays</h1>
                    </div>
                </div>
            </div>

            <div className="smart-upselling-main-container">
                <div className="smart-upselling-main-content-container">
                    <div>
                        <img src={BulbImage} alt="bulb-image" className="bulb-image" />
                    </div>
                    <h1 className="smart-upsselling-main-heading">Smart Upselling Opportunities</h1>
                    <p className="smart-upselling-main-description">Maximize revenue with intelligent recommendations and automated upsell alerts</p>
                </div>

                <div className="smart-upselling-cards-container">

                    <div className="smart-upselling-card">
                        <img src={SmartUpsellingIcon1} alt="smart-upselling-icon" className="smart-upselling-icon" />
                        <h1 className="smart-upselling-card-title">Smart Recommendations</h1>
                        <p className="smart-upselling-card-description">Suggest spa, fine dining, or activities during booking</p>
                    </div>

                    <div className="smart-upselling-card">
                        <img src={SmartUpsellingIcon2} alt="smart-upselling-icon" className="smart-upselling-icon" />
                        <h1 className="smart-upselling-card-title">Upgrade Options</h1>
                        <p className="smart-upselling-card-description">Promote suite upgrades or extended stays automatically</p>
                    </div>

                    <div className="smart-upselling-card">
                        <img src={SmartUpsellingIcon3} alt="smart-upselling-icon" className="smart-upselling-icon" />
                        <h1 className="smart-upselling-card-title">In-App Upsell Alerts</h1>
                        <p className="smart-upselling-card-description">Remind staff to suggest premium services at the right moment</p>
                    </div>

                </div>

                <div className="smart-upselling-button-container">
                    <button className="get-boost-button" onClick={scrollToSection}>🔥 Boost Your Revenue with Smart Upsells →</button>
                </div>
            </div>

            <div className="primary-integration-main-container">
                <div className="primary-integration-content-container">
                    <p className="primary-integration-sub-heading">Our Primary Integrations</p>
                    <h1 className="primary-integration-main-heading">Make productivity easier with 30<span className="primary-span">+ Integrations</span></h1>
                </div>
                <div className="primary-image-container">
                    <img src={PrimaryIntegrationImage} alt="primary-image" className="primary-image" />
                </div>
                <p className="smart-integration-image-description">All Your Channels, One POS Integrate with <b>OTA's and Partners</b> like Expedia, MakeMyTrip, Booking.com, Agoda, plus payment gateways and accounting tools, for seamless business management
                </p>
                <div className="smart-integration-button-section">
                    <button className="see-integration-button" onClick={scrollToSection}>See Integrations →</button>
                </div>
            </div>


            <div className="various-establlishment-main-container-hotel">
                <h1 className="various-establishment-heading-hotel">
                    Versatile Across <span className="various-establishment-span">Various</span> Establishments
                </h1>

                <div className="various-establishment-buttons-container-hotel">
                    {hotelData.map((est, index) => (
                        <button
                            key={index}
                            className={`various-establishment-button-hotel ${selected.name === est.name ? "active" : ""
                                }`}
                            onClick={() => setSelected(est)}
                        >
                            {est.name}
                        </button>
                    ))}
                </div>

                <div className="various-establishment-content-container-hotel">
                    <div className="various-establishment-content-hotel">
                        <h1 className="varous-establishment-title-hotel">{selected.title}</h1>
                        <ul>
                            {selected.points.map((point, index) => (
                                <li key={index} className="various-points-hotel">
                                    {point}
                                </li>
                            ))}
                        </ul>
                    </div>
                    <img
                        src={selected.image}
                        alt={`${selected.name.toLowerCase()}-image`}
                        className="super-market-image-hotel"
                    />
                </div>
            </div>

            <div className="choose-plan-top-main-container">
                <div className="choose-plan-main-container">
                    <div className="choose-plan-heading-section">
                        <h1 className="choose-plan-heading">Choose Your Plan</h1>
                        <p className="choose-plan-description">Streamline your restaurant operations with our comprehensive management solutions</p>
                    </div>
                    <div className="choose-plans-cards-container">

                        <div className="choose-plan-card">
                            <h1 className="plan-title">Standard Plan</h1>
                            <p className="plan-description">Perfect for growing restaurants</p>
                            <h1 className="plan-cost">₹10,000 <span className="price-sub-text">/year/Branch</span></h1>
                            <div className="plan-points-container">
                                <div className="points-plan">
                                    <img src={PointTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">Front Desk Management</p>
                                </div>
                                <div className="points-plan">
                                    <img src={PointTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">Restaurant & Bar Billing</p>
                                </div>
                                <div className="points-plan">
                                    <img src={PointTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">Franchise</p>
                                </div>
                                <div className="points-plan">
                                    <img src={PointTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">Inventory Management</p>
                                </div>
                                <div className="points-plan">
                                    <img src={PointTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">Reports & Analytics</p>
                                </div>
                                <div className="points-plan">
                                    <img src={PointTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">24/7 Support</p>
                                </div>
                                 <div className="points-plan">
                                    <img src={PointTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">Room Inspection (Staff App)</p>
                                </div>
                                <div className="points-plan">
                                    <img src={PointTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">Merchant App</p>
                                </div>
                            </div>
                            <div className="plan-addons-container">
                                <h1 className="plan-addon-heading">Available Add-ons</h1>
                                <div className="whatsapp-plan-container">
                                    <div className="whatsapp-heading">
                                        <img src={WhatsappSmallIcon} alt="whatsapp-icon" className="whatsapp-small-icon" />
                                        <p className="whatsapp-title">whatsapp <span className="plans-all-text">Available with both plans</span></p>
                                    </div>
                                    <p className="plans-fotter-message">₹ 0.15 paisa/per message  (Excluding GST)</p>
                                </div>
                                <div className="plan-button-container">
                                    <button className="plan-buttons">Get Started</button>
                                </div>
                            </div>


                        </div>

                        <div className="choose-plan-card Premium-Plan">
                            <div className="most-popular-button-container">
                                <button className="most-popular">Most Popular</button>
                            </div>
                            <h1 className="plan-title">Premium Plan</h1>
                            <p className="plan-description premium-description">Complete restaurant solution</p>
                            <h1 className="plan-cost">₹15,000 <span className="price-sub-text-premium">/year/Branch</span></h1>
                            <div className="plan-points-container">
                                <div className="points-plan">
                                    <img src={WhiteColorTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text-bold">Smart Upselling Engine</p>
                                </div>
                                <div className="points-plan">
                                    <img src={WhiteColorTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">Advanced Room Booking Module</p>
                                </div>
                                <div className="points-plan">
                                    <img src={WhiteColorTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">Restaurant & Bar Billing</p>
                                </div>
                                <div className="points-plan">
                                    <img src={WhiteColorTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">Reports & Analytics</p>
                                </div>
                                <div className="points-plan">
                                    <img src={WhiteColorTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">Inventory Management</p>
                                </div>
                                <div className="points-plan">
                                    <img src={WhiteColorTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">24/7 Support</p>
                                </div>
                                 <div className="points-plan">
                                    <img src={WhiteColorTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">Room Inspection (Staff App)</p>
                                </div>
                                <div className="points-plan">
                                    <img src={WhiteColorTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">Merchant App</p>
                                </div>
                                <div className="points-plan">
                                    <img src={WhiteColorTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text-bold">Custom branding option</p>
                                </div>
                                <div className="points-plan">
                                    <img src={WhiteColorTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text-bold">OTA's Integrations</p>
                                </div>
                            </div>
                            <div className="plan-addons-container">
                                <h1 className="plan-addon-heading">Available Add-ons</h1>
                                <div className="whatsapp-plan-container Premium-Plan-whatsapp">
                                    <div className="whatsapp-heading">
                                        <img src={WhatsappSmallIcon} alt="whatsapp-icon" className="whatsapp-small-icon" />
                                        <p className="whatsapp-title">whatsapp <span className="plans-all-text">Available with both plans</span></p>
                                    </div>
                                    <p className="plans-fotter-message">₹ 0.15 paisa/per message  (Excluding GST)</p>
                                </div>
                                <div className="plan-button-container">
                                    <button className="plan-buttons premium-button">Get Started</button>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>

            <div className="contact-form-main-container-about" ref={sectionRef}>
                <div className="contact-form-content-container">
                    <div className="contactus-buttons-container">
                        <button
                            className={`contactus-form-buttons ${activeView === 'contact' ? 'active' : ''}`}
                            onClick={() => setActiveView('contact')}
                        >
                            <img src={MessageIcon} alt="message-icon" className="contact-form-icons" />
                            Contact Form
                        </button>

                        <button
                            className={`contactus-form-buttons ${activeView === 'location' ? 'active' : ''}`}
                            onClick={() => setActiveView('location')}
                        >
                            <img src={LocationIcon} alt="location-icon" className="contact-form-icons" />
                            Location
                        </button>
                    </div>



                    {activeView === 'contact' ? (
                        <>
                            <img src={sendMessageImage} alt="send-message-icon" className="send-message-icon" />
                            <h1 className="send-message-heading">Book a Demo</h1>
                            <p className="send-message-description">
                                Fill out the form below and connect us instantly.
                            </p>

                            <form className="send-message-form-main" onSubmit={handleWhatsAppSubmit}>
                                <div className="send-message-form">
                                    <div className="input-container">
                                        <label>Full Name</label>
                                        <input
                                            type="text"
                                            name="name"
                                            placeholder="John Doe"
                                            className="input-field"
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    {/* <div className="input-container">
                                        <label>Email Address</label>
                                        <input
                                            type="email"
                                            name="email"
                                            placeholder="john@example.com"
                                            className="input-field"
                                            onChange={handleChange}
                                            required
                                        />
                                    </div> */}
                                </div>

                                <div className="input-container">
                                    <label>Product</label>
                                    <select
                                        name="product"
                                        className="input-field"
                                        onChange={handleChange}
                                        required
                                    >
                                        {/* <option value="">Select a product</option>
                                        <option value="Fleet Eats">Fleet Eats</option>
                                        <option value="Fleet Mart">Fleet Mart</option> */}
                                        <option value="Fleet Stay">Fleet Stay</option>
                                        {/* <option value="Fleet Office">Fleet Office</option> */}
                                    </select>
                                </div>

                                {/* <div className="input-container">
                                    <label>Message</label>
                                    <textarea
                                        name="message"
                                        placeholder="Type your message here..."
                                        className="input-field"
                                        rows="6"
                                        onChange={handleChange}
                                        required
                                    ></textarea>
                                </div> */}

                                <button type="submit" className="send-message-button">
                                    Connect Us
                                </button>
                            </form>
                        </>
                    ) : (
                        // Location View
                        <div className="map-image-background">
                            <div className="reach-out-cards-container">
                               <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.5253765500493!2d78.37664357522262!3d17.434550583460727!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb93e37831f177%3A0x32d4499d34baaa78!2sT-Hub%20Phase%202!5e0!3m2!1sen!2sin!4v1781782551831!5m2!1sen!2sin" 
                                width="600" 
                                height="450" 
                                style={{ border: 0 }} 
                                allowfullscreen 
                                loading="lazy" 
                                referrerpolicy="no-referrer-when-downgrade"
                                title="Thub Phase 2 Map"
                                ></iframe>
                            </div>
                        </div>

                    )}

                </div>
            </div>
            <Footer />
        </>
    )
}

export default Hotel 